// extracted by mini-css-extract-plugin
export var borderRadius = "_60-4";
export var large = "_60-3";
export var logoContainer = "_60-0";
export var nameLogo = "_60-2";
export var small = "_60-1";